var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditedFinancialsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 137,
    viewBox: "0 0 166 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2028978482"
  }, /*#__PURE__*/React.createElement("g", {
    id: 11
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M84.5933 105.082C112.425 105.082 134.989 82.5258 134.989 54.6036C134.989 26.6814 112.326 4.125 84.5933 4.125C56.7616 4.125 34.1981 26.6814 34.1981 54.6036C34.1981 82.5258 56.7616 105.082 84.5933 105.082Z",
    fill: "#F6EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M131.708 21.5192C133.959 21.5192 135.783 19.6952 135.783 17.4452C135.783 15.1951 133.959 13.3711 131.708 13.3711C129.457 13.3711 127.633 15.1951 127.633 17.4452C127.633 19.6952 129.457 21.5192 131.708 21.5192Z",
    fill: "#F3E7F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M137.672 5.61144C139.209 5.61144 140.455 4.36577 140.455 2.82916C140.455 1.29255 139.209 0.046875 137.672 0.046875C136.135 0.046875 134.889 1.29255 134.889 2.82916C134.889 4.36577 136.135 5.61144 137.672 5.61144Z",
    fill: "#F3E7F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.8816 21.4161C38.4187 21.4161 39.6648 20.1705 39.6648 18.6338C39.6648 17.0972 38.4187 15.8516 36.8816 15.8516C35.3445 15.8516 34.0984 17.0972 34.0984 18.6338C34.0984 20.1705 35.3445 21.4161 36.8816 21.4161Z",
    fill: "#F3E7F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.8844 75.0725C22.739 75.0725 25.0531 72.7591 25.0531 69.9054C25.0531 67.0517 22.739 64.7383 19.8844 64.7383C17.0298 64.7383 14.7156 67.0517 14.7156 69.9054C14.7156 72.7591 17.0298 75.0725 19.8844 75.0725Z",
    fill: "#F3E7F6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M84.5289 77.0942L82.7874 77.1327C82.4391 77.1404 82.1066 76.7845 82.1467 76.335C82.1867 75.8854 82.4699 75.4945 82.8182 75.4868L84.5597 75.4484C84.9081 75.4407 85.2405 75.7966 85.2005 76.2461C85.1362 76.7817 84.8773 77.0865 84.5289 77.0942Z",
    fill: "#D9CEE2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_7",
    filter: "url(#filter0_d_5667_130448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.3526 30.7134L98.195 74.8049C98.8906 76.3324 98.2182 78.1006 96.6642 78.8082L52.5974 98.9804C51.0434 99.688 49.2637 99.046 48.5681 97.5186L22.4755 40.4574C21.7799 38.93 22.4523 37.1618 24.0063 36.4541L55.898 21.8979L77.3526 30.7134Z",
    fill: "url(#paint0_linear_5667_130448)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M55.2811 22.5117L60.6644 34.1912C61.449 35.7965 63.5968 36.4531 65.3304 35.5972L76.6924 30.3513",
    fill: "#E5D5EA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_9",
    filter: "url(#filter1_d_5667_130448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.481 33.4045L113.268 83.2806C113.203 84.9983 111.862 86.4189 110.225 86.4938L63.7416 88.7159C62.104 88.7907 60.8568 87.4973 60.9214 85.7796L63.2457 21.5706C63.3104 19.853 64.6514 18.4323 66.2889 18.3575L99.9109 16.7898L114.481 33.4045Z",
    fill: "url(#paint1_linear_5667_130448)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M99.0037 18.1523L98.8167 31.7817C98.8296 33.6744 100.416 35.2407 102.272 35.1648L114.282 35.0186",
    fill: "#E5D5EA"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_11",
    filter: "url(#filter2_d_5667_130448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.448 54.9302L122.1 101.513C121.388 103.084 119.569 103.853 118.176 103.166L77.506 85.0351C76.0877 84.4346 75.5415 82.5739 76.2529 81.0028L104.333 21.4513C105.044 19.8802 106.863 19.112 108.256 19.7981L137.787 32.9902L143.448 54.9302Z",
    fill: "url(#paint2_linear_5667_130448)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M137.741 34.8047L131.882 47.3899C131.036 49.173 131.814 51.2563 133.477 52.0177L143.934 56.7018",
    fill: "#E5D5EA"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5667_130448",
    x: 0.20166,
    y: 10.8984,
    width: 120.267,
    height: 121.371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5667_130448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5667_130448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5667_130448",
    x: 38.9191,
    y: 5.78906,
    width: 97.5617,
    height: 115.93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5667_130448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5667_130448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5667_130448",
    x: 53.9418,
    y: 8.54688,
    width: 111.507,
    height: 127.871,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5667_130448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5667_130448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5667_130448",
    x1: 54.0916,
    y1: 20.4438,
    x2: 67.611,
    y2: 97.2688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F3ECF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5667_130448",
    x1: 98.9921,
    y1: 14.7149,
    x2: 80.626,
    y2: 93.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F3ECF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5667_130448",
    x1: 123.452,
    y1: 21.3527,
    x2: 105.089,
    y2: 101.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F3ECF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditedFinancialsIcon);
export default __webpack_public_path__ + "static/media/audited-financials-icon.8845633e8b3431ec8b10417bd5e33fcf.svg";
export { ForwardRef as ReactComponent };